module.exports = __webpack_public_path__ + "static/media/pictogram.20a45bd8.jpg";